module.exports = __webpack_public_path__ + "img/4.b1576412.jpg";